import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertService } from 'app/shared/services';

@Component({
    selector: 'app-alert',
    standalone: true,
    imports: [CommonModule],
    template: `
        <div class="app-toasts" role="status" aria-live="polite">
            @for (alert of alerts; track alert) {
                <div class="app-toast app-toast-{{alert.type}}">
                    <pre class="app-toast-msg" [innerHTML]="alert.msg"></pre>
                    @if (alert.count > 1) {
                        <span class="app-toast-count">&times;{{ alert.count }}</span>
                    }
                    <button type="button" class="app-toast-close" aria-label="Close" (click)="alert.close()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            }
        </div>
    `,
    styles: [`
        :host {
            display: contents;
        }

        .app-toasts {
            position: fixed;
            top: 74px;
            right: 12px;
            z-index: 1090;
            display: flex;
            flex-direction: column;
            gap: 8px;
            width: 340px;
            max-width: calc(100vw - 24px);
            pointer-events: none;
        }

        .app-toast {
            display: flex;
            align-items: flex-start;
            gap: 8px;
            padding: 8px 10px;
            border-radius: 6px;
            border-left: 4px solid transparent;
            background-color: #fff;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
            font-size: 0.8125rem;
            pointer-events: auto;
        }

        .app-toast-msg {
            flex: 1 1 auto;
            min-width: 0;
            margin: 0;
            padding: 0;
            border: 0;
            background: none;
            font: inherit;
            color: #212529;
            white-space: pre-wrap;
            overflow-wrap: anywhere;
        }

        .app-toast-count {
            flex: 0 0 auto;
            padding: 1px 6px;
            border-radius: 10rem;
            background-color: #495057;
            color: #fff;
            font-size: 0.6875rem;
            font-weight: 600;
        }

        .app-toast-close {
            flex: 0 0 auto;
            padding: 0;
            border: 0;
            background: none;
            line-height: 1;
            font-size: 1rem;
            color: #adb5bd;
        }

        .app-toast-close:hover {
            color: #495057;
        }

        .app-toast-success {
            border-left-color: #198754;
        }

        .app-toast-danger {
            border-left-color: #dc3545;
        }

        .app-toast-warning {
            border-left-color: #ffc107;
        }

        .app-toast-info {
            border-left-color: #0dcaf0;
        }
    `]})
export class AlertComponent implements OnInit, OnDestroy {
    alerts: any[];

    constructor(private alertService: AlertService) {}

    ngOnInit() {
        this.alerts = this.alertService.get();
    }

    ngOnDestroy() {
        this.alerts = [];
    }
}
